import { Fragment, useContext, useEffect, useState } from "react";
import { Modal } from "bootstrap";

import { Link } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { GlobalContext } from "../../../Context/GlobalContext";
import { axiosWithoutAuth } from "../../../axios/axiosInstance";
import { CardIcon } from "../../../Layout/Common/CardIcon";
import { isValidArray } from "../../../Layout/Common/common";
import { PAGES } from "../../../routeConfig";

export const PayaccountMyWalletPayment = ({ handleOnCheck }) => {
  const { storedCard, selectedCard, setSelectedCard, selectedPaymentType } = useContext(GlobalContext);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (storedCard) {
      if (!selectedCard) {
        var defaultCard = storedCard.find((item) => item.IsExpired == false && item.isdefault == true);
        if (defaultCard) {
          setSelectedCard(defaultCard);
        } else {
          setSelectedCard(null);
        }
      }
    }
  }, [storedCard]);

  return (
    <Fragment>
      {isValidArray(storedCard) &&
        storedCard.map((item, index) => (
          <div className="payment-card-list shipPayment">
            <div className="shipping-method savedCards-details">
              <div className="shipping-method-info pay-option" data-group={index} data-type="wallet">
                <div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="saved-cards"
                    id={"savecard" + index}
                    onChange={(e) => {
                      setSelectedCard(item);
                      handleOnCheck("MYWALLET");
                    }}
                    value="MYWALLET"
                    checked={
                      selectedPaymentType == "MYWALLET" && selectedCard && item.cardUuid == selectedCard.cardUuid
                    }
                    disabled={item.IsExpired}
                  />
                </div>
                <label className="form-check-label" htmlFor={"savecard" + index}>
                  <span>
                    Card Ending in <b>*{item.cardNo}</b>
                    <span className="savedCard-exp">
                      {" "}
                      Expiry: <b>{item.cardExp}</b> {String(item.cardName).slice(0, 18)}
                    </span>
                  </span>
                  {item.IsExpired && (
                    <div className="card-exp-message">
                      <p>
                        <b style={{ color: "red" }}>Card Expiry Date has past. </b>
                        <Link to={PAGES.MYWALLET}>Please update card.</Link>
                      </p>
                    </div>
                  )}
                </label>
              </div>
              <CardIcon cardType={item.cardType || item.card_type} />
            </div>
          </div>
        ))}
    </Fragment>
  );
};
